import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faImage } from "@fortawesome/free-solid-svg-icons"

export const Image = (props) => {
  return <FontAwesomeIcon faIcon={faImage} {...props} />
}
